// tslint:disable:variable-name
import { MultiString } from '../../common/models/index';
import { ApplicationTile } from './Application';
import { ITileWithIcon, TileIcon } from './ITileWithIcon';

export class ApplicationGroup {
    public id: string;
    public display_name: MultiString;
    public icon?: string;
    public params?: {
        groups?: boolean;
        useComponentName?: boolean;
        [param: string]: boolean | number | string;
    };
}

export class ApplicationGroupTile extends ApplicationGroup implements ITileWithIcon {
    public iconView: TileIcon;
    public applications: ApplicationTile[];
}
